import { VStack } from "@/components/Layout";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import PersonProfileHeader from "../../-components/PersonProfileHeader";

/**
 * NOTE: 在籍者プロフィールと同じ（拡張が必要になったら個別に実装）
 */
export const Route = createFileRoute("/_staff/person/alumni/$id/_profile")({
  component: PersonProfile,
});

function PersonProfile() {
  return (
    <VStack>
      <PersonProfileHeader />
      <Outlet />
    </VStack>
  );
}
